export const B2C_TIERS = {
  free: 'free',
  premium: 'premium'
}
